export default __webpack_public_path__ + "static/media/Error.8a407afd.svg";